// Managed OME application config — mirrors the middleware's
// src/apps/omeApplication module (canonical shape = the engine's REST app
// JSON; scalars may come back as strings).

export type OmeScalar = string | number | boolean;

export interface OmeEncodes {
  videos?: { [key: string]: any }[];
  audios?: { [key: string]: any }[];
  images?: { [key: string]: any }[];
}

export interface OmeRendition {
  name?: OmeScalar;
  video?: OmeScalar;
  audio?: OmeScalar;
  [key: string]: any;
}

export interface OmePlaylist {
  name?: OmeScalar;
  fileName?: OmeScalar;
  options?: { [key: string]: any };
  renditions?: OmeRendition[];
  [key: string]: any;
}

export interface OmeOutputProfile {
  name?: OmeScalar;
  outputStreamName?: OmeScalar;
  encodes?: OmeEncodes;
  playlists?: OmePlaylist[];
  [key: string]: any;
}

export interface OmeAppConfig {
  name: string;
  type: OmeScalar; // live | vod
  outputProfiles?: { outputProfile: OmeOutputProfile[] };
  providers?: { [name: string]: any };
  publishers?: { [name: string]: any };
  [key: string]: any;
}

export enum OmeApplicationMode {
  MANAGED = 'managed',
  RAW = 'raw',
}

export enum OmeApplicationImportStatus {
  IMPORTED = 'imported',
  FAILED = 'failed',
  UNSUPPORTED = 'unsupported',
  CREATED = 'created',
}

export enum OmeApplicationApplyState {
  APPLIED = 'applied',
  FAILED = 'failed',
}

export interface OmeApplicationApplyStatus {
  state: OmeApplicationApplyState;
  at: string;
  error?: string;
  engineLogTail?: string;
}

export interface OmeApplicationLintResult {
  id: string;
  severity: 'error' | 'warn';
  message: string;
}

export interface OmeApplication {
  _id: string;
  _server: string;
  name: string;
  mode: OmeApplicationMode;
  config?: OmeAppConfig;
  rawXml?: string;
  sourceXmlHash: string;
  generatedXmlHash?: string;
  revision: number;
  appliedRevision?: number;
  applyStatus?: OmeApplicationApplyStatus;
  notes?: string;
  // Admission-only (not part of config/XML/apply): the default stream profile a
  // bare identity-only URL on this app resolves to, and whether a bare URL with
  // no default is rejected instead of published plainly.
  defaultProfile?: string;
  requireDefaultProfile?: boolean;
  importStatus: OmeApplicationImportStatus;
  updatedBy?: string;
  updatedAt?: string;
  createdAt?: string;
  xmlDrift: boolean;
}

export interface OmeApplicationRevisionEntry {
  _id: string;
  appName: string;
  revision: number;
  action: string;
  author?: string;
  lintResults?: OmeApplicationLintResult[];
  applyResult?: { success: boolean; at: string; durationMs?: number; includedApps?: string[]; error?: string };
  createdAt?: string;
}

export interface GetOmeApplicationsResponse {
  applications: OmeApplication[];
  applyInProgress: boolean;
}

export interface OmeApplicationApplyOutcome {
  success: boolean;
  error?: string;
  lintResults?: { [appName: string]: OmeApplicationLintResult[] };
  verifyMismatches?: string[];
  archivedFileName?: string;
}
